(function () {
	const settings = {
		defaultIsoCode: 'US',
	};
	
	const countriesRadios = [...document.querySelectorAll('[name=calc__country]')]
		.concat([...document.querySelectorAll('[name=countries__country]')]);

	function forceDispatchEvent(isoCode, skipElement) {
		const radioButtons = [...countriesRadios]
			.filter(element => element.value === isoCode && element !== skipElement);

		radioButtons.forEach(radioButton => {
			radioButton.checked = true;
			radioButton.dispatchEvent(new Event('change'))
		})
	}
	
	function initContext() {
		countriesRadios.forEach(countriesRadio => {
			countriesRadio.addEventListener('change', (event) => {
				if (event.isTrusted) {
					localStorage['context'] = countriesRadio.value;
					forceDispatchEvent(countriesRadio.value, countriesRadio); 
				}
			})
		})

		if (localStorage.hasOwnProperty('context') && localStorage.context !== settings.defaultIsoCode) {
			forceDispatchEvent(localStorage.context);
		}
	}

	document.addEventListener('DOMContentLoaded', function () {
		initContext();
	});
})();
